export const CONTENT = "content";
export const CONFIG = "config";

/** Shared */
export const VIDEO_ID = `${CONTENT}.id`;
export const AUTO_PLAY = `${CONTENT}.${CONFIG}.autoplay`;
export const LOOP = `${CONTENT}.${CONFIG}.loop`;

/** Vimeo */
export const CONTROL_COLOR = `${CONTENT}.${CONFIG}.color`;
export const SHOW_TITLE = `${CONTENT}.${CONFIG}.title`;
export const SHOW_BYLINE = `${CONTENT}.${CONFIG}.byline`;
export const SHOW_PORTRAIT = `${CONTENT}.${CONFIG}.portrait`;

/** Youtube */
export const SHOW_CONTROLS = `${CONTENT}.${CONFIG}.controls`;
export const ALLOW_FULLSCREEN = `${CONTENT}.${CONFIG}.fs`;
export const SHOW_RELATED = `${CONTENT}.${CONFIG}.rel`;
export const VIDEO_START = `${CONTENT}.${CONFIG}.start`;
export const VIDEO_END = `${CONTENT}.${CONFIG}.end`;

/** Asset */
export const MUTE = `${CONTENT}.${CONFIG}.muted`;
